//
// Sitewide JavaScript code, front-facing public site
// for common stuff like navbar highlights, tooltips, and other behaviors present on every page
//

$(document).ready(function () {
    initTooltips();
    initActiveNav();
    initFooterLinks();
    initAccessibleHamburger();
});


function initTooltips () {
    setTimeout(function() {
        // with a timeout to allow for dynamic javascript derived tooltips to render
        tippy('[data-tippy-content]', {
            trigger: 'click',
            // Interactive true only if there is a need to interact with the tooltip content, e.g. it contains a link
            // this also impacts aria-describedby: https://atomiks.github.io/tippyjs/v6/accessibility/
            // interactive: true,
            allowHTML: true,
        });
    }, 3000);
}



// if an ACTIVE_NAV global is defined, find that item in the nav menu and tag is as .active so it gets alternate coloring
function initActiveNav() {
	if (typeof ACTIVE_NAV !== 'undefined') {
		$('nav.navbar a').removeClass('active-nav');
		$('nav.navbar a[data-active="'+ACTIVE_NAV+'"]').addClass('active-nav');
    }
}

// for accessibility, we only redirect to external social sites after confirmation 
function initFooterLinks() {
    $('a.social-wrapper').on('click', function(e) {
        e.preventDefault(); 
        // open a SweetAlert modal for confirmation
        swal('You are leaving "ParksForCalifornia.org" for an external website. Click "OK" to continue, or click "Cancel" to stay on the page', {
            buttons: {
            cancel: true,
            confirm: true,
            },
        }).then(function(value) {
            // cancel is null. So if we got a value, then they confirmed, and we redirect to the original href
            if (value) {
                window.location = e.target.href;
            }
        });
    }); 
}

// listen for space or enter on hamburger, to make it act like a button from keyboard
function initAccessibleHamburger() {
    $('body').on('keypress', 'div#bars', function(e) {
        if (e.which === 13 || e.which === 32) {
            e.preventDefault();
            $('div#bars').click();
        } 
    })
}